const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as const;

function padTwoDigits(value: number) {
  return String(value).padStart(2, '0');
}

function formatTwelveHourTime(hour24: number, minute: number, second: number) {
  const period = hour24 >= 12 ? 'PM' : 'AM';
  const normalizedHour = hour24 % 12 === 0 ? 12 : hour24 % 12;
  return `${normalizedHour}:${padTwoDigits(minute)}:${padTwoDigits(second)} ${period}`;
}

function formatParts(year: number, month: number, day: number, hour24: number, minute: number, second: number) {
  const monthLabel = MONTH_LABELS[month - 1];
  if (!monthLabel) {
    return null;
  }

  return `${monthLabel} ${padTwoDigits(day)}, ${year}, ${formatTwelveHourTime(hour24, minute, second)}`;
}

export function formatDisplayDateTime(value: string | null | undefined, fallback = 'N/A') {
  if (value == null) {
    return fallback;
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return fallback;
  }

  const dateTimeMatch = trimmedValue.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/,
  );

  if (dateTimeMatch) {
    const year = Number(dateTimeMatch[1]);
    const month = Number(dateTimeMatch[2]);
    const day = Number(dateTimeMatch[3]);
    const hour24 = Number(dateTimeMatch[4] ?? '0');
    const minute = Number(dateTimeMatch[5] ?? '0');
    const second = Number(dateTimeMatch[6] ?? '0');
    return formatParts(year, month, day, hour24, minute, second) ?? fallback;
  }

  const parsedValue = new Date(trimmedValue);
  if (Number.isNaN(parsedValue.getTime())) {
    return fallback;
  }

  return formatParts(
    parsedValue.getUTCFullYear(),
    parsedValue.getUTCMonth() + 1,
    parsedValue.getUTCDate(),
    parsedValue.getUTCHours(),
    parsedValue.getUTCMinutes(),
    parsedValue.getUTCSeconds(),
  ) ?? fallback;
}